/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
// Mock-Daten für Präsentation - ersetzt Supabase temporär
export const mockCustomers = [
  {
    id: '1',
    customer_number: 10001,
    company_name: 'Mustermann GmbH',
    street: 'Hauptstraße 123',
    postal_code: '21031',
    city: 'Hamburg',
    contact_person: 'Hans Mustermann',
    phone: '+49 40 123456',
    email: 'info@mustermann.de',
    project_number: 'PRJ-2025-001',
    total_budget: 25000,
    status: true
  },
  {
    id: '2', 
    customer_number: 10002,
    company_name: 'Pflegeheim Sonnenschein',
    street: 'Gartenweg 45',
    postal_code: '22457',
    city: 'Hamburg',
    contact_person: 'Maria Schmidt',
    phone: '+49 40 987654',
    email: 'schmidt@sonnenschein.de',
    project_number: 'PRJ-2025-002',
    total_budget: 45000,
    status: true
  }
];

export const mockLocations = [
  {
    id: '1',
    location_number: 'L001',
    customer_id: '1',
    designation: 'Hauptgebäude',
    location_name: 'Mustermann Hauptsitz',
    street: 'Hauptstraße 123',
    postal_code: '21031',
    city: 'Hamburg',
    contact_person: 'Hans Mustermann',
    phone: '+49 40 123456',
    email: 'info@mustermann.de',
    annual_budget: 15000,
    status: true,
    customers: { company_name: 'Mustermann GmbH' }
  },
  {
    id: '2',
    location_number: 'L001', 
    customer_id: '2',
    designation: 'Hauptgebäude',
    location_name: 'Pflegeheim Sonnenschein',
    street: 'Gartenweg 45',
    postal_code: '22457',
    city: 'Hamburg',
    contact_person: 'Maria Schmidt',
    phone: '+49 40 987654',
    email: 'schmidt@sonnenschein.de',
    annual_budget: 30000,
    status: true,
    customers: { company_name: 'Pflegeheim Sonnenschein' }
  }
];

export const mockDoors = [
  {
    id: '1',
    door_number: 'T001',
    delivery_location_id: '1',
    annual_budget: 2000,
    last_inspection_date: '2024-12-01',
    next_inspection_date: '2025-06-01',
    inspection_interval: '6 Monate',
    status: 'funktionsfähig',
    delivery_locations: {
      designation: 'Hauptgebäude',
      customers: { company_name: 'Mustermann GmbH' }
    }
  },
  {
    id: '2',
    door_number: 'T002',
    delivery_location_id: '2',
    annual_budget: 1800,
    last_inspection_date: '2024-11-15',
    next_inspection_date: '2025-05-15',
    inspection_interval: '6 Monate',
    status: 'reparaturbedürftig',
    delivery_locations: {
      designation: 'Hauptgebäude',
      customers: { company_name: 'Pflegeheim Sonnenschein' }
    }
  }
];

const localCustomers = [...mockCustomers];
const localLocations = [...mockLocations];
const localDoors = [...mockDoors];
const localInspections: unknown[] = [];
const localRepairs: unknown[] = [];

// Mock Supabase Client für Demo
export const createMockSupabaseClient = () => ({
  from: (table: string) => ({
    select: (query: string = '*') => ({
      eq: (_column: string, _value: unknown) => ({
        order: (_orderBy: string, _options?: unknown) => Promise.resolve({
          data: getMockData(table, _column, _value),
          error: null
        }),
        then: (callback: any) => callback({
          data: getMockData(table, _column, _value),
          error: null
        })
      }),
      order: (_orderBy: string, _options?: unknown) => Promise.resolve({
        data: getMockData(table),
        error: null
      }),
      then: (callback: any) => callback({
        data: getMockData(table),
        error: null
      })
    }),
    insert: (data: unknown[]) => Promise.resolve({
      data: data.map((item, index) => ({ 
        ...(item as any), 
        id: String(Date.now() + index),
        customer_number: table === 'customers' ? 10000 + localCustomers.length + 1 : undefined
      })),
      error: null
    }),
    update: (data: any) => ({
      eq: (_column: string, _value: unknown) => Promise.resolve({
        data: [data],
        error: null
      })
    }),
    delete: () => ({
      eq: (_column: string, _value: unknown) => Promise.resolve({
        data: [],
        error: null
      })
    })
  })
});

function getMockData(table: string, filterColumn?: string, filterValue?: any) {
  switch (table) {
    case 'customers':
      return filterColumn ? localCustomers.filter(c => (c as any)[filterColumn!] === filterValue) : localCustomers;
    case 'delivery_locations':
      return filterColumn ? localLocations.filter(l => (l as any)[filterColumn!] === filterValue) : localLocations;
    case 'doors':
      return filterColumn ? localDoors.filter(d => (d as any)[filterColumn!] === filterValue) : localDoors;
    case 'inspections':
      return localInspections;
    case 'repairs':
      return localRepairs;
    default:
      return [];
  }
}
